import React, { useState, useCallback } from "react";
import cx from "classnames";
import { noop } from "lodash";

import NxDataTable, { Column } from "@nextiva/crm-datatable";

import Styles from "./DataTableBody.scss";
import { Tooltip } from "@nextiva/next-ui";

const DataTableBody = ({
  isLoading = false,
  data = [],
  displayPreferences = [],
  filterData = null,
  sortData = null,
  onRowClick = noop,
  getRenderer = noop,
  cellRenderer = noop, // not used
  onFiltersChange = noop,
  onSortChange = noop,
  disabledRowTooltipMessage = null,
  className,
  renderActions,
  "data-testid": dataTestId = "AnalyticsSpa-DataTableBody"
}) => {
  const [isTooltipOpened, setIsTooltipOpened] = useState(false);

  const handleSelectRow = useCallback(
    (e, item) => {
      if (item.rowOptions && item.rowOptions.disabled) {
        setIsTooltipOpened(true);
      } else {
        onRowClick(e, item);
      }
    },
    [onRowClick]
  );

  return (
    <div className={cx(Styles.body, className)}>
      <NxDataTable
        isLoading={isLoading}
        data={data}
        renderActions={renderActions}
        displayPreferences={displayPreferences}
        onSortChange={onSortChange}
        onFiltersChange={onFiltersChange}
        onRowClick={handleSelectRow}
        checkable={false}
        disableGear
        data-testid={dataTestId}
      >
        {displayPreferences
          .filter(p => p.display)
          .map(item => {
            const customRenderer = getRenderer?.(item.name);
            const columnProps = {
              name: item.name,
              type: item.type,
              width: item.width,
              resizable: item.resizable,
              options: item.options || [],
              isFixedFilter: !!item.options,
              getCellData: (rowData, name) => rowData[name],
              shouldRenderSort: !!item.shouldRenderSort,
              shouldRenderFilter: !!item.shouldRenderFilter,
              cellRenderer: customRenderer,
              filterData: filterData?.[item.name],
              order: sortData?.key === item.name ? sortData.order : undefined,
              draggableOpts: {
                enableUserSelectHack: false
              }
            };

            return (
              <Column key={item.name} {...columnProps}>
                {item.label}
              </Column>
            );
          })}
      </NxDataTable>

      {disabledRowTooltipMessage && (
        <Tooltip
          dark
          placement="bottom"
          text={disabledRowTooltipMessage}
          isOpen={isTooltipOpened}
          popoverClassName={Styles.tablePopover}
        />
      )}
    </div>
  );
};

export default DataTableBody;
